// Token your native app appends to the WebView user agent
const NATIVE_APP_UA_TOKEN = /KnackMobileApp|GalaxyMobileApp/i;

// In-app browsers (Instagram, Facebook, etc.) look like WebViews but are NOT your app
const THIRD_PARTY_IN_APP_BROWSER =
  /FBAN|FBAV|FB_IAB|Instagram|LinkedInApp|Snapchat|Twitter|Line\/|MicroMessenger|GSA\//i;

export const checkIsMobileDevice = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera || "";
  const isMobileUA = /android|iphone|ipad|ipod|windows phone/i.test(ua);
  const isTouchDevice =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const isNotDevTools = !navigator.webdriver;
  const isSmallScreen = window.innerWidth <= 768;

  return isMobileUA && isTouchDevice && isNotDevTools && isSmallScreen;
};

export const isDeviceIos = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera || "";
  return /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
};

export const isNativeMobileApp = () => {
  if (typeof window === "undefined") return false;

  const ua = navigator.userAgent || navigator.vendor || window.opera || "";

  // 1. Most reliable: custom UA token or injected JS bridge from your app
  if (
    NATIVE_APP_UA_TOKEN.test(ua) ||
    window.ReactNativeWebView ||
    window.KnackNativeApp ||
    window.GalaxyNativeApp
  ) {
    return true;
  }

  // 2. Fallback: generic WebView heuristics (skip third-party in-app browsers)
  if (THIRD_PARTY_IN_APP_BROWSER.test(ua)) return false;

  const isAndroidWebView = /Android/i.test(ua) && /; wv\)/i.test(ua);
  const isIosWebView =
    /iPhone|iPad|iPod/i.test(ua) &&
    /AppleWebKit/i.test(ua) &&
    !/Safari/i.test(ua);

  return isAndroidWebView || isIosWebView;
};